<template lang="pug">
card-financeiro(cardTitle="" :cardStyle="cardStyle")
  template(slot="body")
    slot(name="titulo")
    .searchPanel
      form(v-if='simpleSearch' @submit.prevent="('search', searchValue)")
        el-input(
          :placeholder="placeHolder",
          v-model="searchValue",
          @keyup.native.enter="buscar"
          @input="searchOnChange"
        )
          el-button(
            slot="append",
            @click="buscar"
          )
            i.fal.fa-search.iconColor

      slot(v-if='!simpleSearch && hasPesquisaAvancada' name="pesquisaAvancada")

      .button-group
        .left-buttons
          el-button.no-padding(
            v-if="hasPesquisaAvancada"
            type="text",
            @click="changeTipoPesquisa"
          ) {{ tipoPesquisa }}
          el-button.no-padding(
            type="text",
            @click="limpar"
          ) Limpar
        .advanced-search-button
          el-button(
            v-if="!simpleSearch"
            type="success",
            @click="pesquisarAvancado"
            size="small"
          )
            i.fal.fa-search
            | &nbsp Pesquisar

</template>

<script>
import CardFinanceiro from '@/screens/financeiro/components/CardFinanceiro.vue'
/**
 * Esse componente possui a pesquisa simples e recebe por slot, a pesquisa avançada
 *
 */
export default {
  components: {
    CardFinanceiro
  },

  props: {
    /**
     * Placeholder da pesquisa
     */
    placeHolder: {
      type: String,
      required: false
    },
    /**
     * Se terá uma pesquisa avançada
     */
    hasPesquisaAvancada: {
      type: Boolean,
      default: false,
      required: false
    },

    isSearchOnChange: {
      type: Boolean,
      default: false
    },

    cardStyle: {
      required: false
    }
  },

  data () {
    return {
      simpleSearch: true,
      searchValue: ''
    }
  },

  computed: {
    tipoPesquisa () {
      return this.simpleSearch ? 'Pesquisa avançada' : 'Pesquisa simplificada'
    },

    tituloPesquisa () {
      return this.simpleSearch ? 'Pesquisa simplificada' : 'Pesquisa avançada'
    }
  },

  methods: {
    /**
     * Aciona a pesquisa com o termo da pesquisa simples
     *
     * @property {string} searchValue a string a ser pesquisada
     */
    buscar () {
      this.$emit('search', this.searchValue)
    },

    /**
     * Limpa os campos da pesquisa simples
     *
     * @property {number} newPage a nova pagina que irá para o filtro da paginação
     */
    limpar () {
      this.searchValue = ''
      this.buscar()
      this.$emit('resetSearch', this.resetSearch)
    },

    /**
     * Altera a pesquisa de simples para avançada
     *
     */
    changeTipoPesquisa () {
      this.limpar()
      this.simpleSearch = !this.simpleSearch
      this.$emit('setCardTitle', this.tituloPesquisa)
      this.$emit('changeTipoPesquisa', this.simpleSearch)
    },

    /**
     * Aciona o metodo de pesquisar da pesquisa avançada
     *
     */
    pesquisarAvancado () {
      this.$emit('searchAdvanced')
    },

    searchOnChange () {
      if (this.isSearchOnChange) this.buscar()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/element-variables.scss';

h1 {
  margin-top: 0px;
}

.iconColor {
  color: $--color-text-secondary;
}

.searchPanel {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;

  .button-group {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }
}

.advanced-search-button {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pesquisa.vue